import React from 'react';
import DateFormat from '..';

const Short = props => (
  <DateFormat
    className="short"
    format={{ month: '2-digit', day: '2-digit', year: '2-digit' }}
    {...props}
  />
);

export default Short;
